import styled, { css } from "styled-components";
import fipayFonts from "../../../theme";
import { colors } from "../../../theme/color";

interface CalendarLinkTextProps {
  specialStyle?: boolean;
}

export const EmptyDashboardContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const EmptyDashboard = styled.div`
  /* margin-top: 100px; */
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 11;
`;

export const NotFound = styled.img`
  width: 93px;
  height: 94px;
  object-fit: cover;
`;

export const CalendarText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.footer1};
  color: ${colors.LIGHT_GRAY};
`;

export const CalendarLinkText = styled.div<CalendarLinkTextProps>`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.footer1};
  color: ${colors.DARK_GRAY};

  /* Conditionally apply styles based on the prop */
  ${(props) =>
    props.specialStyle &&
    css`
      font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
      color: ${colors.BLACK};
      padding: 15px 0px 10px;
    `}
`;
